import HowItWorks from '../../../HowItWorks/HowItWorks'
import React from 'react'
import { NavLink } from 'react-router-dom';
import { faEnvelope , faMoneyBill, faMoneyBillWave, faCalendarCheck} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faFacebook, faTwitter, faLinkedin, faDribbble, faInstagram, faPaypal, } from '@fortawesome/free-brands-svg-icons'


function Process() {
    return (
        <>
        <div className="">
            <div style={{margin:20, marginTop:0, padding:"20px"}}><span style={{fontSize:18, fontWeight:600}} >We offer very convenient way of trad in your device (s) and get paid by the preferred payment method like Cash, E-transfer(Interac) and PayPal. We pay instantly upon receiving your device (s) once its passed our inspection, there is no hold on payment.

</span></div>
            
            <div className="p-2">
                    <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
                      <span style={{fontSize:21, fontWeight:700, textAlign:"left", margin:20}}>  How it works(Shipping label method): </span>
                      <div className='grid-container'>
                          <div style={{backgroundColor:"", borderStyle:"", marginTop:"10px", boxShadow:"3px 4px 2px gray"}} className='grid-item '>
                          <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
                          <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
                          <div className="grid-container1 ml-2 ">
                          <i class="fa fa-check-square fa-2x"></i>
                          <i class="fa fa-check-square fa-2x"></i>
                          <i class="fa fa-check-square fa-2x"></i>
                          
                          </div>
                          
                          </div>
                           <div className='text-dark mb-2 mt-2 justify-content-center'>
                            
                              <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                              <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                              <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                            
                                
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
                          </div>
                             
                          <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                          <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
                          <div><i class="fa fa-truck fa-6x" style={{color:"", marginLeft:""}} ></i></div>
                          </div>
                           <div className='ext-dark mb-2 mt-2 justify-content-center'>
                                <span  style={{fontSize:16, fontWeight:600}}className='p-2'>We'll send you a prepaid shipping label right after the submission to your email.</span>
                                <span  style={{fontSize:16, fontWeight:600, }}className=''>You will use provided shipping label to send your device(s) to us at no cost to you.</span>
                              <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You can schedule pickup with carrier or drop it off yourself.</span>
                             
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
                           </div>
                            
                              
                          <div style={{backgroundColor:"floral-white",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                          <div className=''> 
                          <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
                          </div>
                          <div className='text-dark mb-2 mt-2 justify-content-center'>
                                <span  style={{fontSize:16, fontWeight:600}}className=''>Upon receiving device (s), we inspect the device (s) to validate the information provided by you on website.</span>
                                <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                                <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
                           </div>
                                
                        
                      </div> 
                    </div>
                    <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
                      <span style={{fontSize:19, fontWeight:700, textAlign:"left", margin:20}}>  How it works(In person meeting method): </span>
                      <div className='grid-container'>
                          <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item '>
                          <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
                          <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
                          <div className="grid-container1 ml-2 ">
                          <i class="fa fa-check-square fa-2x"></i>
                          <i class="fa fa-check-square fa-2x"></i>
                          <i class="fa fa-check-square fa-2x"></i>
                          
                          </div>
                          
                          </div>
                           <div className='text-dark mb-2 mt-2 justify-content-center'>
                            
                              <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                              <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                              <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                            
                                
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
                          </div>
                             
                          <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                          <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
                          <div><FontAwesomeIcon icon={faCalendarCheck} style={{fontSize:"100px"}}/></div>
                          </div>
                           <div className='ext-dark mb-2 mt-2 justify-content-center'>
                                <span  style={{fontSize:16, fontWeight:600}}className='p-2'>Our assocciate will contanct you, to schedule an appointment with you as per your availability.</span>
                                <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''>You will receive appointment cofirmation details on your email. </span>
                                <span  style={{fontSize:16, fontWeight:600, }}className=''>You will meet our associate at your scheduled time and place.</span>
                            
                             
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
                           </div>
                            
                              
                          <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                          <div className=''> 
                          <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
                          </div>
                          <div className='text-dark mb-2 mt-2 justify-content-center'>
                                <span  style={{fontSize:16, fontWeight:600}}className=''>Associate will inspect the device (s) on the spot and validate the information provided by you on website.</span>
                                <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                                <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                              </div>
                              <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
                           </div>
                                
                        
                      </div> 
                    </div>
                    <div className='bg-light p-2 '>
                  <span style={{fontSize:20, fontWeight:800, textAlign:"left", margin:20}}>  Get paid instantly by preffered payment options: </span>
                  <div className='grid-container'>
                        <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray" ,display:"flex", columnGap:"1x"}}className=''>
                        
                          <div style={{boxShadow:"",}}className='w-50 '>
                          <div style={{fontSize:"60px", marginLeft:"2rem"}} className="w-80">
                          <FontAwesomeIcon icon={faPaypal} />
                          </div>
                         
                          </div>
                         <div className='p-2 ml-2'> 
                         <span style={{fontSize:16, fontWeight:700}}> Get paid instantly, just provide your email address to get paid by PayPal.</span>
                         </div>
                   </div>
                         
                   
                       <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray", display:"flex", columnGap:"1x" }}className='  '>
                          <div className='w-50'>
                          <img className="w-75 p-1 ml-2 mt-3" style={{background:''}} src="https://cash4device.s3.ca-central-1.amazonaws.com/payment_method/Interac_Brand_2021.png"></img>
                          </div>
                          <div className='p-2 ml-2'> 
                          <span style={{fontSize:16, fontWeight:700}}className="">Get paid instantly, just provide your email address to get paid by interac.</span>
                          </div>
                         </div>
                       
                          
                        <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray" ,display:"flex", columnGap:"1x"}}className=' '>
                        <div className='w-50'>
                          <img className=" w-80 p-2 ml-2 " style={{background:''}} src="https://cash4device.s3.ca-central-1.amazonaws.com/payment_method/payment-icon-5646.png"></img>
                          </div>
                          <div style={{marginLeft:"20px"}}className='p-2 '> 
                          <span style={{fontSize:15, fontWeight:700, }}className="">Get paid instantly, Schedule a meeting to meet in person with our associate to get paid cash.</span>
                         </div>
                          </div>
                  </div> 
                </div>
         
                    </div>
                    
        </div>
        
        </>
       
    
    )
}

export default Process